import { useSelector } from "react-redux";
import { isBool } from "@cayuse/shared-react.utils.type-checks";

import { tenantSelectors } from "store/selectors";


export const useFormBuilderType = () => {
	const { simplifiedFormBuilderEnabled } = useSelector(tenantSelectors.tenant);

	if(isBool(simplifiedFormBuilderEnabled)) {
		return simplifiedFormBuilderEnabled ? "simple" : "advanced";
	} else {
		return "simple";
	}
};

export default useFormBuilderType;
